import { CR, DISABLED, EZ, HPC } from './types';
import { getProductCtasLabels } from '../../../globals/utils/labels/labels';
import { HpcProductSelector } from './hpc-product-selector/hpc-product-selector';
import { EzProductSelector } from './ez-product-selector/ez-product-selector';
import { ScProductSelector } from './sc-product-selector/sc-product-selector';
import { SC } from '@pes-ui/utils/lib/constants';
export const updateProductCtasSelectorSettings = (data, productCtasButtons) => {
  const isCartCtaAvailable = productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.cart.isShown;
  const isFavoritesCtaAvailable = productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.favorites.isShown;
  const isButtonAvailable = isCartCtaAvailable || isFavoritesCtaAvailable;
  const addCartLabel = (productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.cart.labels.addLabel) || (data && getProductCtasLabels(data).addToCartLabel);
  const addFavoritesLabel = (productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.favorites.labels.addLabel)
    || (data && getProductCtasLabels(data).addToMyProductsLabel);
  const productCtasLabel = isCartCtaAvailable
    ? addCartLabel
    : isFavoritesCtaAvailable
      ? addFavoritesLabel
      : '';
  return {
    buttons: {
      saveConfiguration: {
        title: productCtasLabel,
        isVisible: isButtonAvailable,
      },
    },
  };
};
const selectorType = {
  configuration: 'configuration',
  productSelector: 'productSelector',
  easySelector: 'easySelector',
  functionModel: 'functionModel',
  semtech: 'semtech',
};
const selectGroupID = (configurationEvent) => {
  if (configurationEvent.type === selectorType.configuration) {
    return configurationEvent.configurationId;
  }
  return '';
};
const formedProductsArr = (productsSC) => {
  const newArr = [];
  productsSC.forEach((item) => {
    const adjustedItem = {
      productId: item.reference,
      quantity: item.quantity || 1,
    };
    if (item.extras) {
      const customizationId = item.extras['custom-configuredReference1'];
      const productCr = item.extras['custom-configuredReference2'];
      if (customizationId) {
        adjustedItem.customizationId = customizationId;
      }
      if (productCr) {
        adjustedItem.productCr = productCr;
      }
    }
    newArr.push(adjustedItem);
  });
  return newArr;
};
export const scConfigurationToPostData = (configurationEvent) => {
  const { orderingId, codification, configurationName } = configurationEvent.extras || {};
  return {
    products: formedProductsArr(configurationEvent.products),
    grouping: {
      enable: true,
      displayName: configurationName || '',
      configurationMasterId: selectGroupID(configurationEvent) || '',
      quantity: configurationEvent.quantity || 1,
      backURL: '',
      extras: {
        codification,
        orderingId,
      },
    },
    options: {
      allowPartialAdding: true,
      source: `ps_${configurationEvent.type}`,
    },
  };
};
export const scSprykerConfigurationToPostData = (configurationEvent) => {
  const { orderingId, codification, configurationName } = configurationEvent.extras || {};
  return {
    data: {
      type: 'my-products',
      attributes: {
        products: formedProductsArr(configurationEvent.products),
        grouping: {
          enable: true,
          displayName: configurationName || '',
          configurationMasterId: selectGroupID(configurationEvent) || '',
          quantity: configurationEvent.quantity || 1,
          backURL: '',
          extras: {
            codification,
            orderingId,
          },
        },
        options: {
          allowPartialAdding: true,
          source: `ps_${configurationEvent.type}`,
        },
      },
    },
  };
};
export const switchProductSelector = (config) => {
  switch (config.type) {
    case EZ:
      return EzProductSelector.init(config);
    case SC:
      return ScProductSelector.init(config);
    case HPC:
    case CR:
      return HpcProductSelector.init(config);
    case DISABLED:
    default:
      return Promise.resolve(null);
  }
};
